import {Pagination} from '@app/core/models/pagination.model';
import {Activity} from '@app/core/models/activity.model';
import {User} from '@app/core/models/user.model';
import {Group} from '@app/core/models/group.model';

export interface IActivityState {
	activities: Activity[];
	users: { [user_id: number]: User };
	groups: { [group_id: number]: Group };
	activity: Activity;
	pagination: Pagination;
	isLoading: boolean;
	isLoadingActivity: boolean;
	isLoadingRelationActivity: boolean;
}

export const initialActivityState: IActivityState = {
	activities: [],
	users: {},
	groups: {},
	activity: undefined,
	pagination: undefined,
	isLoading: false,
	isLoadingActivity: false,
	isLoadingRelationActivity: false,
};
